import React from 'react';

/**
 * Parses text content and replaces emote codes (e.g., :musePog:) with image elements.
 * @param {string} content - The raw text content.
 * @param {Function} getEmoteUrl - Function to resolve emote code to URL.
 * @returns {React.ReactNode} - React fragment with text and images.
 */
export const parseContentWithEmotes = (content, getEmoteUrl) => {
    if (!content) return null;

    // Regex for :emote_code:
    const parts = content.split(/(:[a-zA-Z0-9_]+:)/g);

    return React.createElement('span', { style: { wordBreak: 'break-word', lineHeight: '1.5' } },
        parts.map((part, index) => {
            if (part.startsWith(':') && part.endsWith(':')) {
                // Determine URL (reactive to theme)
                const url = getEmoteUrl ? getEmoteUrl(part) : null;

                if (url) {
                    return React.createElement('img', {
                        key: index,
                        src: url,
                        alt: part,
                        title: part,
                        style: { height: '24px', verticalAlign: 'middle', margin: '0 2px' }
                    });
                }
            }
            return part;
        })
    );
};
